<template>
	<Panel :title="trans('users.labels.password_settings')">
		<span v-if="!pwaStore.onlineAndConnected" class="small text-muted mb-2">You must be online to update this setting.</span>
		<form @submit.prevent="onFormSubmit">
			<TextInput v-model="form.currentPassword" type="password" :required="true" :label="trans('users.labels.current_password')" name="current-password" class="mb-4" :disabled="!pwaStore.onlineAndConnected"/>
			<hr>
			<TextInput v-model="form.password" type="password" :required="true" :label="trans('users.labels.new_password')" name="password" class="mb-4" :disabled="!pwaStore.onlineAndConnected"/>
			<TextInput v-model="form.passwordConfirm" type="password" :required="true" :label="trans('users.labels.confirm_password')" name="password-confirm" class="mb-4" :disabled="!pwaStore.onlineAndConnected"/>

			<UiButton type="submit" :label="trans('global.buttons.update')" :disabled="!pwaStore.onlineAndConnected" />
		</form>
	</Panel>
</template>

<script>

	import AuthService from "@/services/AuthService";
	import { trans } from "@/helpers/i18n";
	import { reactive, defineComponent } from "vue";
	import { useAlertStore } from "@/stores";
	import { usePwaStore } from "@/stores/pwa";
	import { getResponseError } from "@/helpers/api";
	import UiButton from "@/views/components/input/UiButton.vue";
	import TextInput from "@/views/components/input/TextInput.vue";
	import Panel from "@/views/components/Panel";

	export default defineComponent({
		components: {
			Panel,
			UiButton,
			TextInput
		},
		setup () {

			const authService = new AuthService();
			const alertStore = useAlertStore();
			const pwaStore = usePwaStore();
			const form = reactive({
				currentPassword: null,
				password: null,
				passwordConfirm: null
			});

			async function onFormSubmit () {
				const payload = {
					current_password: form.currentPassword,
					password: form.password,
					password_confirmation: form.passwordConfirm
				};
				await authService.updatePassword(payload)
					.then((response) => (alertStore.success(trans("global.phrases.password_updated"))))
					.catch((error) => {
						alertStore.error(getResponseError(error));
						console.log(error);
					}
					);
			}

			return {
				onFormSubmit,
				form,
				trans,
				pwaStore
			};
		}
	});
</script>
